/********************************************************************************
 * Copyright (c) 2020 Cedalo GmbH
 *
 * This program and the accompanying materials are made available under the 
 * terms of the Eclipse Public License 2.0 which is available at
 * http://www.eclipse.org/legal/epl-2.0.
 *
 * SPDX-License-Identifier: EPL-2.0
 *
 ********************************************************************************/
export const MESSAGE_ADD = 'message_add';
export const SHEET_STEP = 'sheet_step';
export const SHEET_UPDATE = 'sheet_update';
export const STREAMSHEET_STEP = 'streamsheet_step';
export const MACHINE_RENAME = 'machine_rename';
export const STREAMSHEET_CREATE = 'streamsheet_create';
export const STREAMSHEET_DELETE = 'streamsheet_delete';
export const STREAMSHEET_STREAM_UPDATE_TYPE = 'STREAMSHEET_STREAM_UPDATE_TYPE';
export const MACHINE_STATE = 'machine_state';
export const MACHINESERVER_MACHINES = 'machineserver_machines';
export const MACHINE_SAVE_AS = 'machine_save_as';
export const MACHINE_STREAM_EXPORT = 'machine_stream_export';
export const MACHINE_STREAM_IMPORT = 'machine_stream_import';
export const MACHINE_DELETE = 'machine_delete';
export const MACHINE_LOAD = 'machine_load';
export const MACHINE_UPDATE_SETTINGS = 'machine_update_settings';
export const MACHINE_UPDATE_EXTENSION_SETTINGS = 'machine_update_extension_settings';
export const REDO = 'redo';
export const UNDO = 'undo';

// TODO: check use of the following on server side:
export const MACHINE_SUBSCRIBE = 'machine_subscribe';
export const MACHINE_UNSUBSCRIBE = 'machine_unsubscribe';
export const MACHINE_START = 'machine_start';
export const MACHINE_STOP = 'machine_stop';
export const MACHINE_PAUSE = 'machine_pause';
export const MACHINE_STEP = 'machine_step';

// general request failure...
export const REQUEST_FAILED = 'REQUEST_FAILED';

